import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { useConnectivity } from '../../hooks/useConnectivity';

// =====================================================================
// iSentinel360 v0.4.1 — ClientFooter
//
// Extracted from src/pages/ClientDashboard.tsx. Lightest of the
// four — no store name (cadmin sees all stores at once), just the
// user and the version.
//
// Hides itself when the user is offline for the same reason as
// GuardFooter.
// =====================================================================

declare const __APP_VERSION__: string;

export default function ClientFooter() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { isOnline } = useConnectivity();

  if (!isOnline) return null;

  return (
    <div className="flex-shrink-0">
      <footer className="text-center text-xs text-muted-foreground py-3 border-t">
        <div className="text-xs text-muted-foreground/70">
          {t('guard.user')}: {user?.name || 'Unknown'}
        </div>
        <span className="opacity-60">v.{__APP_VERSION__}</span>
      </footer>
    </div>
  );
}
